<template>
  <div v-if="hasAttachments">
    <Attachments
      :attachments="attachmentList"
      :disableUpload="disableUpload"
      :showPreview="showPreview"
      :allowDelete="allowDelete"
      :sample="sample"
      @removeAttachments="$emit('removeAttachments', $event)"
    />
  </div>
</template>

<script>
import Attachments from '@common/components/Attachments';

export default {
  name: 'IsolatedAttachments',
  components: {
    Attachments,
  },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    disableUpload: {
      type: Boolean,
      default: true,
    },
    showPreview: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
    sample: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attachmentList: [],
      hasAttachments: false,
    };
  },
  created() {
    this.attachmentList = this.attachments || [];
    this.hasAttachments = this.attachmentList.length > 0;
  },
  watch: {
    attachments: {
      handler(newVal) {
        if (newVal && newVal.length !== this.attachmentList.length) {
          this.attachmentList = [...newVal];
          this.hasAttachments = this.attachmentList.length > 0;
        }
      },
    },
  },
};
</script>
